import { LeafTypes, NodeType } from 'shared/types/ingestion'
import { ILeaf, INode } from 'shared/types/tree'

export function isLeafType(type: unknown): type is LeafTypes {
  return (
    typeof type === 'string' && Object.values<string>(LeafTypes).includes(type)
  )
}

export function isNodeType(type: unknown): type is NodeType {
  return (
    typeof type === 'string' && Object.values<string>(NodeType).includes(type)
  )
}

function hasTreeIds(obj: object) {
  return 'tree_id' in obj && 'version' in obj && 'id' in obj
}

export function isLeaf(item: unknown): item is ILeaf {
  if (!item || typeof item !== 'object') return false
  if ('type' in item) {
    return hasTreeIds(item) && isLeafType(item.type)
  }
  return false
}

export function isNode(item: unknown): item is INode {
  if (!item || typeof item !== 'object') return false

  if (!('type' in item) || !hasTreeIds(item)) return false

  if (!isNodeType(item.type)) return false

  if (isLeaf(item)) {
    return 'nodes' in item
  }
  return true
}
